import React, { ReactNode, useState } from 'react'

import { DashboardNavbar } from '../components/Navigation/dashboardNavbar'
import { DashboardSidebar } from '../components/Navigation/dashboardSidebar'
import { ChatPanel, ChatProvider, useChatContext } from '../components/chat'
import ErrorPopUp from '../components/userFeedback/messagePopUp'
import useSites from '../hooks/useSites'
import styles from '../styles/dashboardLayoutStyles.module.css'
import { theme } from '../styles/theme'

interface DashboardLayoutProps {
    children: ReactNode
}

const DashboardLayoutInner = ({ children }: DashboardLayoutProps) => {
    const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth >= theme.breakpoints.values.lg)
    const { isOpen: isChatOpen } = useChatContext()

    // Warm the sites list in SWR's global cache so the ROI filter
    // dropdowns and brand-name resolution are ready by the time the
    // user navigates into ROI.
    useSites()

    const handleSidebarToggle = () => setSidebarOpen(!isSidebarOpen)

    const contentClasses = [
        styles.content,
        isSidebarOpen ? styles.sidebarOpen : '',
        isChatOpen ? styles.chatOpen : '',
    ].join(' ')

    return (
        <div className={styles.dashboard}>
            <DashboardNavbar handleSidebarToggle={handleSidebarToggle} />
            <DashboardSidebar
                handleSideBarToggle={handleSidebarToggle}
                onClose={handleSidebarToggle}
                open={isSidebarOpen}
            />
            <ErrorPopUp style={contentClasses} />
            <div className={contentClasses}>{children}</div>
            <ChatPanel />
        </div>
    )
}

export const DashboardLayout = ({ children }: DashboardLayoutProps) => (
    <ChatProvider>
        <DashboardLayoutInner>{children}</DashboardLayoutInner>
    </ChatProvider>
)
